import { render, staticRenderFns } from "./UiTableSellReport.vue?vue&type=template&id=4752805b&scoped=true"
import script from "./UiTableSellReport.vue?vue&type=script&lang=js"
export * from "./UiTableSellReport.vue?vue&type=script&lang=js"
import style0 from "./UiTableSellReport.vue?vue&type=style&index=0&id=4752805b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4752805b",
  null
  
)

export default component.exports